import {
  EAmenityType,
  EBuildingClassType,
  EBuildingCraneType,
  EBuildingElevatorType,
  EBuildingGatesType,
  EBuildingHeatingType,
  EBuildingStatus,
  EBuildingType,
  ECategoryType,
  EConditionType,
  EContractType,
  ECurrencyType,
  EElevators,
  EEntranceType,
  EEstateType,
  EGarageKind,
  EGarageMaterial,
  EGarageStatus,
  EGarageType,
  EHeatingType,
  EHouseLineType,
  EHouseMaterial,
  ELandStatusType,
  ELayoutType,
  EMaxPrepay,
  EMetroTravelType,
  EObjectType,
  EOfficeType,
  EParkingType,
  EPlacementType,
  EPropertyType,
  EPublishPeriod,
  ERentTime,
  ERepair,
  ERoomsTotal,
  ERoomType,
  ESaleType,
  ESortValue,
  ESuburbanOfferFilter,
  ESuburbanWCType,
  ETenant,
  EWCType,
  EWindowsType,
  ECoworkingOfferType,
  EJsonQueryPriceType,
} from './enums';
import { IJsonQueryGeo } from './geo';

export type IJsonQueryType =
  | 'flatrent'
  | 'flatsale'
  | 'newobjectsale'
  | 'commercialrent'
  | 'commercialsale'
  | 'suburbanrent'
  | 'suburbansale';

export interface IJsonQueryTerm<T> {
  type: 'term';
  value: T;
}

export interface IJsonQueryTerms<T> {
  type: 'terms';
  value: T[];
}

export interface IJsonQueryRangeValue {
  gte?: number;
  lte?: number;
}

export interface IJsonQueryRange {
  type: 'range';
  value: IJsonQueryRangeValue;
}

export interface IJsonQueryTermsParams {
  bs_center?: IJsonQueryTerms<number>;
  building_class_type__warehouse?: IJsonQueryTerms<EBuildingClassType>;
  building_class_type?: IJsonQueryTerms<EBuildingClassType>;
  building_cranage_types_type?: IJsonQueryTerms<EBuildingCraneType>;
  building_gates_type?: IJsonQueryTerms<EBuildingGatesType>;
  building_heating_type?: IJsonQueryTerms<EBuildingHeatingType>;
  building_house_line_type__shopping_area?: IJsonQueryTerms<EHouseLineType>;
  building_house_line_type?: IJsonQueryTerms<EHouseLineType>;
  building_lift_types_type?: IJsonQueryTerms<EBuildingElevatorType>;
  building_type__building?: IJsonQueryTerms<EBuildingType>;
  building_type2?: IJsonQueryTerms<EBuildingType>;
  category?: IJsonQueryTerms<ECategoryType>;
  composition?: IJsonQueryTerms<ETenant>;
  condition_type__free_appointment_object?: IJsonQueryTerms<EConditionType>;
  condition_type__industry?: IJsonQueryTerms<EConditionType>;
  condition_type?: IJsonQueryTerms<EConditionType>;
  contract?: IJsonQueryTerms<EContractType>;
  description_exclude?: IJsonQueryTerms<string>;
  description_include?: IJsonQueryTerms<string>;
  estate_type?: IJsonQueryTerms<EEstateType>;
  garage_garage_type?: IJsonQueryTerms<EGarageKind>;
  garage_material?: IJsonQueryTerms<EGarageMaterial>;
  garage_status?: IJsonQueryTerms<EGarageStatus>;
  garage_type?: IJsonQueryTerms<EGarageType>;
  heating_source_type?: IJsonQueryTerms<EHeatingType>;
  house_material?: IJsonQueryTerms<EHouseMaterial>;
  input_type?: IJsonQueryTerms<EEntranceType>;
  land_status?: IJsonQueryTerms<ELandStatusType>;
  object_type?: IJsonQueryTerms<EObjectType>;
  office_type?: IJsonQueryTerms<EOfficeType>;
  coworking_offer_type?: IJsonQueryTerms<ECoworkingOfferType>;
  parking_type?: IJsonQueryTerms<EParkingType>;
  placement_type?: IJsonQueryTerms<EPlacementType>;
  property_type?: IJsonQueryTerms<EPropertyType>;
  region?: IJsonQueryTerms<number>;
  repair?: IJsonQueryTerms<ERepair>;
  room?: IJsonQueryTerms<ERoomType>;
  rooms_count?: IJsonQueryTerms<ERoomsTotal>;
  sost_type?: IJsonQueryTerms<ESaleType>;
  specialty_types?: IJsonQueryTerms<number>;
  status?: IJsonQueryTerms<number>;
  year?: IJsonQueryTerms<number>;
  amenity?: IJsonQueryTerms<EAmenityType>;
}

export interface IJsonQueryBooleanParams {
  demolished_in_moscow_programm?: IJsonQueryTerm<boolean>;
  enter?: IJsonQueryTerm<boolean>;
  has_video?: IJsonQueryTerm<boolean>;
}

export interface IJsonQueryInfrastructureParams {
  has_electricity?: IJsonQueryTerm<boolean>;
  has_extinguishing_system?: IJsonQueryTerm<boolean>;
  has_heating?: IJsonQueryTerm<boolean>;
  has_light?: IJsonQueryTerm<boolean>;
  has_water?: IJsonQueryTerm<boolean>;
  infrastructure_has_aquapark?: IJsonQueryTerm<boolean>;
  infrastructure_has_atm?: IJsonQueryTerm<boolean>;
  infrastructure_has_automatic_gates?: IJsonQueryTerm<boolean>;
  infrastructure_has_baby_sitting?: IJsonQueryTerm<boolean>;
  infrastructure_has_bank_department?: IJsonQueryTerm<boolean>;
  infrastructure_has_basement?: IJsonQueryTerm<boolean>;
  infrastructure_has_beauty_shop?: IJsonQueryTerm<boolean>;
  infrastructure_has_bowling?: IJsonQueryTerm<boolean>;
  infrastructure_has_buffet?: IJsonQueryTerm<boolean>;
  infrastructure_has_cafe?: IJsonQueryTerm<boolean>;
  infrastructure_has_canteen?: IJsonQueryTerm<boolean>;
  infrastructure_has_car_service?: IJsonQueryTerm<boolean>;
  infrastructure_has_car_wash?: IJsonQueryTerm<boolean>;
  infrastructure_has_central_reception?: IJsonQueryTerm<boolean>;
  infrastructure_has_cinema?: IJsonQueryTerm<boolean>;
  infrastructure_has_clothes_studio?: IJsonQueryTerm<boolean>;
  infrastructure_has_conference_room?: IJsonQueryTerm<boolean>;
  infrastructure_has_entry_by_pass?: IJsonQueryTerm<boolean>;
  infrastructure_has_exhibition_and_warehouse_complex?: IJsonQueryTerm<boolean>;
  infrastructure_has_fitness_centre?: IJsonQueryTerm<boolean>;
  infrastructure_has_food_court?: IJsonQueryTerm<boolean>;
  infrastructure_has_game_room?: IJsonQueryTerm<boolean>;
  infrastructure_has_hotel?: IJsonQueryTerm<boolean>;
  infrastructure_has_hour_security?: IJsonQueryTerm<boolean>;
  infrastructure_has_inspection_pit?: IJsonQueryTerm<boolean>;
  infrastructure_has_medical_center?: IJsonQueryTerm<boolean>;
  infrastructure_has_minimarket?: IJsonQueryTerm<boolean>;
  infrastructure_has_notary_office?: IJsonQueryTerm<boolean>;
  infrastructure_has_office_space?: IJsonQueryTerm<boolean>;
  infrastructure_has_park?: IJsonQueryTerm<boolean>;
  infrastructure_has_pharmacy?: IJsonQueryTerm<boolean>;
  infrastructure_has_pool?: IJsonQueryTerm<boolean>;
  infrastructure_has_restaurant?: IJsonQueryTerm<boolean>;
  infrastructure_has_rink?: IJsonQueryTerm<boolean>;
  infrastructure_has_shopping_area?: IJsonQueryTerm<boolean>;
  infrastructure_has_slot_machines?: IJsonQueryTerm<boolean>;
  infrastructure_has_studio?: IJsonQueryTerm<boolean>;
  infrastructure_has_supermarket?: IJsonQueryTerm<boolean>;
  infrastructure_has_tire?: IJsonQueryTerm<boolean>;
  infrastructure_has_video_surveillance?: IJsonQueryTerm<boolean>;
  infrastructure_has_warehouse?: IJsonQueryTerm<boolean>;
}

export interface IJsonQuery extends IJsonQueryTermsParams, IJsonQueryBooleanParams {
  _type: IJsonQueryType;
  engine_version: IJsonQueryTerm<number>;

  apartment?: IJsonQueryTerm<boolean>;
  all_day_access?: IJsonQueryTerm<number>;
  all_week_access?: IJsonQueryTerm<number>;
  balconies?: IJsonQueryRange;
  bath?: IJsonQueryTerm<boolean>;
  bathhouse?: IJsonQueryTerm<boolean>;
  bbox?: IJsonQueryTerm<[[number, number], [number, number]]>;
  bedroom_total?: IJsonQueryRange;
  bs_center_id?: IJsonQueryTerm<number>;
  build_quarter?: IJsonQueryTerm<number>;
  build_year?: IJsonQueryTerm<number>;
  building_status?: IJsonQueryTerm<EBuildingStatus>;
  ceiling_height?: IJsonQueryRange;
  cl?: IJsonQueryTerm<boolean>;
  commission_type?: IJsonQueryTerm<number>;
  conditioner?: IJsonQueryTerm<boolean>;
  contact?: IJsonQueryTerm<string>;
  currency?: IJsonQueryTerm<ECurrencyType>;
  deal_rent?: IJsonQueryTerm<boolean>;
  developer_sort_type?: IJsonQueryTerm<string>;
  dish_washer?: IJsonQueryTerm<boolean>;
  domrf?: IJsonQueryTerm<boolean>;
  electricity?: IJsonQueryTerm<boolean>;
  floor?: IJsonQueryRange;
  floorn?: IJsonQueryRange;
  foot_min?: IJsonQueryRange;
  for_day?: IJsonQueryTerm<ERentTime>;
  from_developer?: IJsonQueryTerm<boolean>;
  from_jk?: IJsonQueryTerm<boolean>;
  from_mcad_km?: IJsonQueryRange;
  from_offrep?: IJsonQueryTerm<boolean>;
  garage?: IJsonQueryTerm<boolean>;
  gas?: IJsonQueryTerm<boolean>;
  geo?: IJsonQueryGeo;
  hand_over?: IJsonQueryTerm<boolean>;
  has_decoration?: IJsonQueryTerm<boolean>;
  has_drainage?: IJsonQueryTerm<boolean>;
  has_electricity?: IJsonQueryTerm<boolean>;
  has_equipment?: IJsonQueryTerm<boolean>;
  has_extinguishing_system?: IJsonQueryTerm<boolean>;
  has_fridge?: IJsonQueryTerm<boolean>;
  has_furniture?: IJsonQueryTerm<boolean>;
  has_heating?: IJsonQueryTerm<boolean>;
  has_kitchen_furniture?: IJsonQueryTerm<boolean>;
  has_light?: IJsonQueryTerm<boolean>;
  has_washer?: IJsonQueryTerm<boolean>;
  has_water?: IJsonQueryTerm<boolean>;
  house_year?: IJsonQueryRange;
  id_user?: IJsonQueryTerm<number>;
  id?: IJsonQueryTerm<number>;
  include_new_moscow?: IJsonQueryTerm<boolean>;
  internet?: IJsonQueryTerm<boolean>;
  ipoteka?: IJsonQueryTerm<boolean>;
  is_basement?: IJsonQueryTerm<boolean>;
  is_by_homeowner?: IJsonQueryTerm<boolean>;
  is_by_commercial_owner?: IJsonQueryTerm<boolean>;
  is_first_floor?: IJsonQueryTerm<boolean>;
  is_in_hidden_base?: IJsonQueryTerm<boolean>;
  is_in_kp?: IJsonQueryTerm<boolean>;
  is_semibasement?: IJsonQueryTerm<boolean>;
  isWCfixed?: boolean;
  jk_flat_type_id?: IJsonQueryTerm<string>;
  kids?: IJsonQueryTerm<boolean>;
  kitchen?: IJsonQueryRange;
  kp_id?: IJsonQueryTerm<number>;
  lift_service?: IJsonQueryRange;
  lifts?: IJsonQueryTerm<EElevators>;
  living_area?: IJsonQueryRange;
  loggia?: IJsonQueryTerm<boolean>;
  multi_id?: IJsonQueryTerm<number>;
  identical_id?: IJsonQueryTerm<number>;
  not_last_floor?: IJsonQueryTerm<boolean>;
  only_flat?: IJsonQueryTerm<boolean>;
  only_foot?: IJsonQueryTerm<EMetroTravelType>;
  page?: IJsonQueryTerm<number>;
  penthouse?: IJsonQueryTerm<boolean>;
  pets?: IJsonQueryTerm<boolean>;
  phone?: IJsonQueryTerm<boolean>;
  pool?: IJsonQueryTerm<boolean>;
  prepay?: IJsonQueryTerm<EMaxPrepay>;
  price_sm?: IJsonQueryTerm<boolean>;
  price?: IJsonQueryRange;
  price_type?: IJsonQueryTerm<EJsonQueryPriceType>;
  promo?: IJsonQueryTerm<boolean>;
  publish_period?: IJsonQueryTerm<EPublishPeriod>;
  quality?: IJsonQueryTerm<boolean>;
  room_area?: IJsonQueryRange;
  room_type?: IJsonQueryTerm<ELayoutType>;
  rooms_for_sale?: IJsonQueryRange;
  security?: IJsonQueryTerm<boolean>;
  shower?: IJsonQueryTerm<boolean>;
  site?: IJsonQueryRange;
  sort?: IJsonQueryTerm<ESortValue>;
  suburban_offer_filter?: IJsonQueryTerm<ESuburbanOfferFilter>;
  total_area?: IJsonQueryRange;
  tv?: IJsonQueryTerm<boolean>;
  wc_site?: IJsonQueryTerm<ESuburbanWCType>;
  wc_type?: IJsonQueryTerm<EWCType>;
  wc?: IJsonQueryRange;
  windows_type?: IJsonQueryTerm<EWindowsType>;
  with_newobject?: IJsonQueryTerm<boolean>;
  wp?: IJsonQueryTerm<boolean>;
  yeargte?: IJsonQueryTerm<number>;
  zalog?: IJsonQueryTerm<boolean>;
  saved_search_id?: IJsonQueryTerms<string>;
  /** Пригород */
  with_neighbors?: IJsonQueryTerm<boolean>;
  /** Планировка */
  with_layout?: IJsonQueryTerm<boolean>;
  is_pik_promo?: IJsonQueryTerm<boolean>;
  workplace_count?: IJsonQueryRange;
  coworking_id?: IJsonQueryTerms<number>;
}

export * from './geo';
export * from './enums';
